export const restructureToGroupArray = (apiResponse) => {
  const result = {
    status: 1,
    data: {
      data: [],
      status: "success",
      message: "Converted with separated groups into classments",
    },
  };

  // Check if apiResponse and apiResponse.data exist
  if (!apiResponse || !apiResponse.data) {
    console.error("Invalid API response structure:", apiResponse);
    return result;
  }

  // Use an empty object as fallback if apiResponse.data is null
  const responseData = apiResponse.data || {};

  for (const [groupName, teams] of Object.entries(responseData)) {
    // Check if teams exists and is an array
    if (!teams || !Array.isArray(teams)) {
      console.warn(`Invalid or empty teams data for group ${groupName}`);
      continue; // Skip this iteration
    }

    const classments = teams.map((team) => ({
      position: team.position || 0,
      club_id: team.id,
      picture_url: team?.school?.school_logo || "",
      club_name: team?.school?.school_name || "",
      club_short_name: (team?.school?.school_name || "").split(" ")[0], // basic short name
      play: team.played || 0,
      win: team.won || 0,
      draw: team.drawn || 0,
      lose: team.lost || 0,
      gf: team.goals_for || 0,
      ga: team.goals_against || 0,
      gd: team.goal_difference || 0,
      point: team.points || 0,
      supporter_point: team.supporter_point || 0,
      forms: team.form || [],
    }));

    result.data.data.push({
      name: groupName,
      stage_type_id: 1, // assuming 1 = group stage
      classments: classments,
    });
  }

  return result;
};

// Infografis "Struktur Kompetisi Piala by.U": SMA 16 tim dibagi 4 grup (A-D)
// isi 4 tim, SMP 8 tim dibagi 2 grup (A-B). Kampus sama kayak SMP: 8 timnya
// langsung masuk series tanpa kualifikasi, dibagi 2 grup (A-B) isi 4 tim.
const PREVIEW_GROUP_COUNT = {
  SMA: 4,
  SMP: 2,
  Kuliah: 2,
};

const TEAM_PER_GROUP = 4;

export const buildPreviewGroups = (activeClassLevel = "SMA") => {
  const groupCount = PREVIEW_GROUP_COUNT[activeClassLevel] ?? 0;

  return Array.from({ length: groupCount }, (_, groupIndex) => ({
    name: `Group ${String.fromCharCode(65 + groupIndex)}`,
    stage_type_id: 1,
    classments: Array.from({ length: TEAM_PER_GROUP }, (_, teamIndex) => ({
      position: teamIndex + 1,
      club_id: `preview-${groupIndex}-${teamIndex}`,
      picture_url: "",
      club_name: `Tim ${groupIndex * TEAM_PER_GROUP + teamIndex + 1}`,
      club_short_name: `Tim ${groupIndex * TEAM_PER_GROUP + teamIndex + 1}`,
      play: 0,
      win: 0,
      draw: 0,
      lose: 0,
      gf: 0,
      ga: 0,
      gd: 0,
      point: 0,
      supporter_point: 0,
      forms: [],
    })),
  }));
};
